const BASE_URL = process.env.REACT_APP_BASE_DOMAIN || "vietnam-backend-1039339270759.asia-southeast1.run.app";
const API_PREFIX = process.env.REACT_APP_API_PREFIX || "https://";
const WS_PREFIX = process.env.REACT_APP_WS_PREFIX || "wss://";

export const API_URL = `${API_PREFIX}${BASE_URL}`;
export const WS_URL = `${WS_PREFIX}${BASE_URL}`;
